import { render, staticRenderFns } from "./DisplayType.vue?vue&type=template&id=da95b224&scoped=true&"
import script from "./DisplayType.vue?vue&type=script&lang=ts&"
export * from "./DisplayType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da95b224",
  null
  
)

export default component.exports